import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import CustomField from "components/form/CustomField";
import { handleSubmitForm } from "helpers/apiUtils";
import { loginUser } from "store/slices/authSlice";

import { encryptText, decryptText } from "helpers/cryptoUtils";
import { Images } from "assets/images";
import { useTranslation } from "react-i18next";
import { loginSchema } from "utils/validations";
// import GoogleCaptcha from "components/common/GoogleCaptcha";
import { showAlert } from "store/slices/alertSlice";
import { Eye, EyeOff } from "lucide-react";

const Login = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading } = useSelector((state) => state.Auth);

  const { logo } = Images || {};

  const [googleCaptchaToken, setGoogleCaptchaToken] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // Read encrypted values
  const savedEmail = decryptText(
    localStorage.getItem("remember_email") || "superadmin@tartish.sa"
  );
  const savedPassword = decryptText(
    localStorage.getItem("remember_password") || "Tartish@#2025!"
  );

  const handleSubmit = (values) => {
    // if (!googleCaptchaToken)
    //   return dispatch(
    //     showAlert({
    //       text: t("Captcha verification failed. Please try again."),
    //       type: "error",
    //     })
    //   );
    const payload = {
      email: values.email,
      password: values.password,
    };

    // REMEMBER ME WITH ENCRYPTION
    if (values.remember) {
      localStorage.setItem("remember_email", encryptText(values.email));
      localStorage.setItem("remember_password", encryptText(values.password));
    } else {
      localStorage.removeItem("remember_email");
      localStorage.removeItem("remember_password");
    }

    handleSubmitForm({
      dispatch,
      action: loginUser,
      payload,
      onSuccess: () => navigate("/dashboard"),
    });
  };

  return (
    <div className="page-content login_page d-flex justify-content-center align-items-center">
      <div
        className="login-box p-4 shadow-sm rounded bg-white"
        style={{ width: "380px" }}
      >
        {/* Logo */}
        <div className="text-center mb-4">
          <img src={logo} alt={t("Logo")} width={100} height={55} />
        </div>

        <h4 className="text-center mb-3">{t("Login")}</h4>

        <Formik
          initialValues={{
            email: savedEmail,
            password: savedPassword,
            remember: savedEmail || savedPassword ? true : false,
          }}
          validationSchema={loginSchema(t)}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange }) => (
            <Form>
              <div className="form_field">
                <CustomField
                  name="email"
                  type="email"
                  label={t("Email")}
                  placeholder={t("Enter email")}
                />
              </div>
              <div className="form_field position-relative">
                <CustomField
                  name="password"
                  type={showPassword ? "text" : "password"}
                  label={t("Password")}
                  placeholder={t("Enter password")}
                />
                <button
                  className="transparent_btn show_hide_password_btn"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>

              <div className="g_between">
                <div className="d-flex align-items-center my-2">
                  <input
                    type="checkbox"
                    id="remember"
                    name="remember"
                    checked={values.remember}
                    onChange={handleChange}
                    className="me-2"
                  />
                  <label htmlFor="remember" className="m-0">
                    {t("Remember Me")}
                  </label>
                </div>
                <Link
                  to="/forgot-password"
                  className="forget_password_link"
                >
                  {t("Forgot password?")}
                </Link>
              </div>

              {/* <GoogleCaptcha setGoogleCaptchaToken={setGoogleCaptchaToken} /> */}

              <button
                type="submit"
                className="main_btn w-100 mt-3"
                disabled={isLoading}
              >
                {isLoading ? t("Logging in...") : t("Login")}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Login;
